var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0719 3.53872C26.0881 3.97458 25.0313 4.26908 23.9203 4.4022C25.0667 3.71636 25.9243 2.63693 26.3332 1.36532C25.2562 2.00496 24.0774 2.45519 22.8481 2.69645C22.0215 1.81397 20.9266 1.22905 19.7334 1.0325C18.5402 0.835948 17.3155 1.03876 16.2494 1.60946C15.1833 2.18015 14.3355 3.0868 13.8376 4.18863C13.3396 5.29046 13.2195 6.52583 13.4957 7.70295C11.3133 7.59339 9.1784 7.02625 7.22944 6.03833C5.28049 5.0504 3.56107 3.66378 2.18278 1.96845C1.7115 2.78127 1.44052 3.72367 1.44052 4.72732C1.44 5.63084 1.66253 6.52052 2.08838 7.31743C2.51423 8.11433 3.13023 8.79382 3.88172 9.2956C3.01019 9.26788 2.15789 9.03242 1.39575 8.60883V8.67951C1.39566 9.94673 1.83407 11.175 2.63659 12.1558C3.43912 13.1366 4.55631 13.8096 5.79863 14.0606C4.99014 14.2794 4.1425 14.3116 3.31973 14.1549C3.67023 15.2452 4.35299 16.1987 5.27241 16.8818C6.19183 17.565 7.30189 17.9435 8.44719 17.9645C6.50298 19.4905 4.10191 20.3182 1.63021 20.3146C1.19237 20.3147 0.754908 20.2892 0.320068 20.238C2.82898 21.8509 5.74954 22.7069 8.73231 22.7036C18.8293 22.7036 24.3491 14.3422 24.3491 7.09039C24.3491 6.85479 24.3433 6.61683 24.3326 6.38123C25.4063 5.6049 26.3331 4.64356 27.0696 3.54226L27.0719 3.53872Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/TwitterIcon.41b2dcbb37d7e57b7987e5dfd4285a22.svg";
export { ForwardRef as ReactComponent };